<app-icon name="search" class="is-size-4 has-text-black-grey"></app-icon>

<app-input-text [formControl]="searchControl" updateOn="change"
  [placeholder]="'common-settings.__SEARCH' | AsyncLang | async" [hasEdit]="false" class="has-spacing-left-m is-size-6">
</app-input-text>
